import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PinAuthenticationService } from '../services/pin-authentication.service';
import { Router } from '@angular/router';
import { SignInService } from '../services/sign-in.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private pinAuthenticationService: PinAuthenticationService, private router: Router, private signInService: SignInService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap(
				event => {},
				error => {
					if (error.status == 401) {
						if (!this.pinAuthenticationService.isAnonUserAuthenticated) {
							this.pinAuthenticationService.removePinSession();
						}
						
						if (!this.signInService.isUserAuthenticated) {
							this.signInService.removeUserSession();
						}
					}
				}
			)
		)
	}
}